export {Icon, type IconProps, type IconName} from './Icon';
